import { ReactNode, FC } from "react";
import { MainNavbar } from "./MainNavbar";

export const PageLayout: FC<{ children: ReactNode }> = ({ children }) => {
  return <>
    <MainNavbar />
    {children}
  </>;
};